import React from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const personNumberSelectionProps = {
    style: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.string.isRequired,
    id: PropTypes.number,
    label: PropTypes.string,
};

type PersonSelectionProps = PropTypes.InferProps<typeof personNumberSelectionProps>;

const PersonNumberSelection: React.FC<PersonSelectionProps> = ({
    style,
    onChange,
    defaultValue,
    id,
    label,
}: PersonSelectionProps) => (
    <FormControl style={style}>
        {label && <InputLabel id="person-number-select-label">{label}</InputLabel>}
        <Select
            id={`${id ?? ""}-person-number-select`}
            onChange={e => (id == null ? onChange(e.target.value) : onChange(id, e.target.value))}
            defaultValue={defaultValue}
        >
            <MenuItem key="none" value="none">
                None
            </MenuItem>
            <MenuItem key="2" value="2">
                2
            </MenuItem>
            <MenuItem key="3" value="3">
                3
            </MenuItem>
            <MenuItem key="4" value="4">
                4
            </MenuItem>
            <MenuItem key="5" value="5">
                5
            </MenuItem>
            <MenuItem key="6" value="6">
                6
            </MenuItem>
            <MenuItem key="7" value="7">
                7
            </MenuItem>
            <MenuItem key="8" value="8">
                8
            </MenuItem>
        </Select>
    </FormControl>
);

export default PersonNumberSelection;
